module.exports = __webpack_public_path__ + "img/電気回路_4_8_3.22fb2fcf.png";